import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { ConfirmDialogModule } from 'primeng/confirmdialog'
import { InputTextareaModule } from 'primeng/inputtextarea'
import { ToggleButtonModule } from 'primeng/togglebutton'
import { ConfirmPopupModule } from 'primeng/confirmpopup'
import { OverlayPanelModule } from 'primeng/overlaypanel'
import { AutoCompleteModule } from 'primeng/autocomplete'
import { HttpClientModule } from '@angular/common/http'
import { MultiSelectModule } from 'primeng/multiselect'
import { SplitButtonModule } from 'primeng/splitbutton'
import { ContextMenuModule } from 'primeng/contextmenu'
import { ProgressBarModule } from 'primeng/progressbar'
import { InputSwitchModule } from 'primeng/inputswitch'
import { InputNumberModule } from 'primeng/inputnumber'
import { RadioButtonModule } from 'primeng/radiobutton'
import { FileUploadModule } from 'primeng/fileupload'
import { BreadcrumbModule } from 'primeng/breadcrumb'
import { CalendarIcon } from 'primeng/icons/calendar'
import { InputTextModule } from 'primeng/inputtext'
import { InputMaskModule } from 'primeng/inputmask'
import { PanelMenuModule } from 'primeng/panelmenu'
import { NgxCsvParserModule } from 'ngx-csv-parser'
import { MegaMenuModule } from 'primeng/megamenu'
import { CalendarModule } from 'primeng/calendar'
import { DropdownModule } from 'primeng/dropdown'
import { PasswordModule } from 'primeng/password'
import { FieldsetModule } from 'primeng/fieldset'
import { TimelineModule } from 'primeng/timeline'
import { CheckboxModule } from 'primeng/checkbox'
import { DragDropModule } from 'primeng/dragdrop'
//* La tabla compartida pinta su esqueleto de carga con `p-skeleton`: el módulo tiene que entrar AQUÍ.
//* Estar importado en `app.module.ts` no alcanza — los componentes declarados en SharedModule no ven
//* lo que importa el módulo raíz, y el fallo sale como «'p-skeleton' is not a known element» en el
//* log de `ng serve`, no en `tsc --noEmit`.
import { SkeletonModule } from 'primeng/skeleton'
import { MessageModule } from 'primeng/message'
import { TooltipModule } from 'primeng/tooltip'
import { ToolbarModule } from 'primeng/toolbar'
import { DividerModule } from 'primeng/divider'
import { TabViewModule } from 'primeng/tabview'
import { SidebarModule } from 'primeng/sidebar'
import { CommonModule } from '@angular/common'
import { ButtonModule } from 'primeng/button'
import { DialogModule } from 'primeng/dialog'
import { RippleModule } from 'primeng/ripple'
import { SliderModule } from 'primeng/slider'
import { AvatarModule } from 'primeng/avatar'
import { TableModule } from 'primeng/table'
import { ToastModule } from 'primeng/toast'
import { PanelModule } from 'primeng/panel'
import { BadgeModule } from 'primeng/badge'
import { ChartModule } from 'primeng/chart'
import { CardModule } from 'primeng/card'
import { MenuModule } from 'primeng/menu'
import { ChipModule } from 'primeng/chip'
import { NgModule } from '@angular/core'
import { TagModule } from 'primeng/tag'

import { ChannelLabelPipe } from '@modules/private/omnichannel/data/pipes/channel-label.pipe'
import { IfHasPermissionDirective } from '../core/directives/if-has-permissions.directive'
import { HasPermissionDirective } from '../core/directives/has-permission.directive'
import { SelectEnumPipe } from '@data/pipes/enum/select-enum.pipe'
import { TimeElapsedPipe } from '@data/pipes/time-elapsed.pipe'
import { MxDatePipe } from '@data/pipes/mx-date.pipe'
import * as fromComponents from './components'

@NgModule({
  declarations: [...fromComponents.components, SelectEnumPipe, TimeElapsedPipe, MxDatePipe, ChannelLabelPipe, HasPermissionDirective, IfHasPermissionDirective],
  imports: [
    CommonModule,
    HttpClientModule,
    ButtonModule,
    TableModule,
    SidebarModule,
    TagModule,
    FormsModule,
    ReactiveFormsModule,
    MegaMenuModule,
    InputTextModule,
    InputMaskModule,
    ContextMenuModule,
    PanelMenuModule,
    MenuModule,
    MessageModule,
    MultiSelectModule,
    CalendarModule,
    CalendarIcon,
    DropdownModule,
    SliderModule,
    ProgressBarModule,
    CardModule,
    RippleModule,
    BreadcrumbModule,
    ToastModule,
    ToolbarModule,
    SplitButtonModule,
    DialogModule,
    PasswordModule,
    ConfirmDialogModule,
    AvatarModule,
    InputSwitchModule,
    InputNumberModule,
    FileUploadModule,
    FieldsetModule,
    FontAwesomeModule,
    NgxCsvParserModule,
    TabViewModule,
    ProgressSpinnerModule,
    ChipModule,
    ConfirmPopupModule,
    TimelineModule,
    OverlayPanelModule,
    AutoCompleteModule,
    RadioButtonModule,
    InputTextareaModule,
    CheckboxModule,
    ToggleButtonModule,
    DividerModule,
    PanelModule,
    BadgeModule,
    TooltipModule,
    DragDropModule,
    NgxExtendedPdfViewerModule,
    ChartModule,
    SkeletonModule,
  ],
  exports: [
    ...fromComponents.components,
    CommonModule,
    HttpClientModule,
    ButtonModule,
    TableModule,
    SidebarModule,
    TagModule,
    FormsModule,
    ReactiveFormsModule,
    MegaMenuModule,
    InputTextModule,
    InputMaskModule,
    ContextMenuModule,
    PanelMenuModule,
    MenuModule,
    MessageModule,
    MultiSelectModule,
    CalendarModule,
    CalendarIcon,
    DropdownModule,
    SliderModule,
    ProgressBarModule,
    CardModule,
    RippleModule,
    BreadcrumbModule,
    ToastModule,
    ToolbarModule,
    SplitButtonModule,
    DialogModule,
    PasswordModule,
    ConfirmDialogModule,
    AvatarModule,
    InputSwitchModule,
    InputNumberModule,
    FileUploadModule,
    FieldsetModule,
    FontAwesomeModule,
    NgxCsvParserModule,
    TabViewModule,
    ProgressSpinnerModule,
    ChipModule,
    ConfirmPopupModule,
    TimelineModule,
    OverlayPanelModule,
    AutoCompleteModule,
    RadioButtonModule,
    SelectEnumPipe,
    TimeElapsedPipe,
    MxDatePipe,
    ChannelLabelPipe,
    InputTextareaModule,
    CheckboxModule,
    HasPermissionDirective,
    IfHasPermissionDirective,
    ToggleButtonModule,
    DividerModule,
    PanelModule,
    BadgeModule,
    TooltipModule,
    DragDropModule,
    ChartModule,
  ],
})
export class SharedModule {}
